//angular imports
import {
  ChangeDetectionStrategy,
  Component,
  OnDestroy,
  signal,
  WritableSignal,
} from "@angular/core";

//local imports
import { CatalogConstants, RoomModel } from "@app/catalog";
import { BreadcrumbItemToggleMessage, IBreadcrumbItemModel, Messenger, PresenterType } from "@app/shared";
import { Subject } from "rxjs";

@PresenterType({
  model: RoomModel,
  key: 'tileTop'
})
@Component({
  selector: 'room-carousel-item',
  templateUrl: './room-carousel-item.component.html',
  styleUrl: './room-carousel-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class RoomCarouselItemComponent implements OnDestroy {
  public data: WritableSignal<RoomModel> = signal<RoomModel>(undefined);


  constructor(private messenger: Messenger)
  {}

  public addToBreadCrumb(item: IBreadcrumbItemModel) {
    if(!this.data().shouldAddBreadcrumb()) {
      return;
    }
    this.messenger.send(new BreadcrumbItemToggleMessage(item, CatalogConstants.CATALOG));
  }

  ngOnDestroy() {
    this.messenger.unsubscribeByOwner(this);
  }
}
